import React from 'react';

import Container from 'components/Container';
import Grid from 'components/Grid';

import Card from './components/Card';

const Information = () => (
	<Container>
		<Grid colDefault={2} colTabletLarge={4} colMobileLarge={2}>
			<Card
				title="Участники"
				text={
					<span>
						Граждане России в&nbsp;возрасте от&nbsp;
						<b>14</b>
						&nbsp;до&nbsp;
						<b>22</b>
						&nbsp;лет
					</span>
				}
				image="/images/pushkinsCard/information/participants.png"
				type="participants"
				imageWidth={219}
				imageHeight={154}
			/>
			<Card
				title="Программа"
				text={
					<span>
						<b>Покупка билетов</b> в&nbsp;театры, музеи, филармонии, кинотеатры
						и&nbsp;др.&nbsp;на&nbsp;средства из&nbsp;федерального бюджета
					</span>
				}
				image="/images/pushkinsCard/information/tickets.png"
				type="tickets"
				imageWidth={257}
				imageHeight={228}
			/>
			<Card
				title="Номинал карты"
				text={
					<span>
						В&nbsp;<b>2024</b>&nbsp;году номинал Пушкинской карты составляет{' '}
						<b>5000</b>&nbsp;рублей
					</span>
				}
				image="/images/pushkinsCard/information/card.png"
				type="card"
				imageWidth={220}
				imageHeight={230}
			/>
			<Card
				title="Билеты онлайн"
				text={
					<span>
						В&nbsp;афише приложения <b>Госуслуги.Культура</b>{' '}
						и&nbsp;на&nbsp;портале <b>Культура.РФ</b>
					</span>
				}
				image="/images/pushkinsCard/information/app.png"
				type="app"
				imageWidth={155}
				imageHeight={148}
			/>
		</Grid>
	</Container>
);

export default Information;
